import { DetailedChangeLogDto } from '@act/shared/data-transfer-objects';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Skeleton,
  Typography,
} from '@mui/material';
import { Fragment, useEffect } from 'react';
import { changeLogRequests } from 'redux/requests/change-log.requests';
import { useApiCall } from 'redux/utils/apiHook.hook';
import { GenericDialogProps } from 'utilities/dialog-context/DialogContextHelpers';
import './change-log-dialog.scss';
import { CloseButton } from './components/SharedDialogHookComponents';

export interface ChangeLogDialogUniqueProps {
  memberId: string;
}

export type ChangeLogDialogProps = GenericDialogProps<boolean> &
  ChangeLogDialogUniqueProps;

export type ChangeLogDialogCallbackInput = {};

export const ChangeLogDialog = ({
  memberId,
  open,
  setOpen,
  callback,
}: ChangeLogDialogProps) => {
  const [changeLogs, isGettingChangeLogs, getChangeLogs] = useApiCall(
    changeLogRequests.getMemberChangeLogs
  );

  useEffect(() => {
    getChangeLogs({ params: { memberId } });
  }, []);

  const handleClose = () => {
    setOpen(false);
    callback(true);
  };

  function formatChangeLogs(
    changeLogs: DetailedChangeLogDto[]
  ): React.ReactNode {
    return (
      <Fragment>
        {changeLogs.map(log => {
          return (
            <Fragment key={log.id}>
              {log.detailedChanges.map(change => {
                return (
                  <p key={change.label}>
                    <Typography variant="titleSmall">{change.label}</Typography>
                    <br />
                    <Typography variant="bodyLarge">{change.value}</Typography>
                  </p>
                );
              })}
            </Fragment>
          );
        })}
      </Fragment>
    );
  }

  return (
    <Dialog
      className="context-dialog"
      open={open}
      onClose={handleClose}
      maxWidth="xs"
    >
      <DialogTitle className="context-dialog__title">
        <Typography variant="titleLarge">Member file update</Typography>
        <CloseButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      </DialogTitle>
      <DialogContent className="context-dialog__content">
        {isGettingChangeLogs && (
          <Fragment>
            <Fragment>
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
            </Fragment>
          </Fragment>
        )}
        {changeLogs && (
          <Fragment>{formatChangeLogs(changeLogs.changeLogs)}</Fragment>
        )}
      </DialogContent>
    </Dialog>
  );
};
